/**
 * og-pdp-complete.js — 修复版 v8
 * 修复1：Toast文案改为"Added to cart"
 * 修复2：多变体产品按钮改为"Choose"跳产品页
 * 修复3：加购失败跳转产品页选规格
 * 保留：formatPrice / buildCardHTML / renderIntoPlaceholders /
 *        clearPlaceholders / fallbackToLatestProducts /
 *        fillWithRecommendations / Toast控制 / 事件委托
 */

(function () {
  'use strict';

  // ── 工具：安全转义防XSS ──────────────────────────────────────
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ── 工具：用Shopify原生货币格式输出价格（无小数点）──────────
  function formatPrice(rawPrice) {
    if (rawPrice == null || rawPrice === '') return '';
    var num = parseFloat(rawPrice);
    if (isNaN(num)) return '';
    var str = String(rawPrice);
    var amount;
    if (str.indexOf('.') !== -1) {
      amount = num;
    } else {
      amount = num / 100;
    }
    var moneyFormat = (window.Shopify && window.Shopify.money_format)
      ? window.Shopify.money_format
      : '${{amount_no_decimals}}';
    var amountStr = amount.toFixed(2);
    var amountNoDecimals = String(Math.round(amount));
    var amountWithComma = amountStr.replace('.', ',');
    var amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    moneyFormat = moneyFormat.replace('{{amount}}', '{{amount_no_decimals}}');
    return moneyFormat
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma);
  }

  // ── 构建产品卡 HTML ──────────────────────────────────────────
  function buildCardHTML(product) {
    var image = product.images && product.images[0];
    var imageHTML = '';
    if (image) {
      var src400 = image.src.replace(/(\.[^.]+)$/, '_400x$1');
      var src600 = image.src.replace(/(\.[^.]+)$/, '_600x$1');
      var src800 = image.src.replace(/(\.[^.]+)$/, '_800x$1');
      imageHTML = '<img'
        + ' class="og-pdp-complete__card-img"'
        + ' src="' + escapeHtml(src600) + '"'
        + ' srcset="' + escapeHtml(src400) + ' 400w, ' + escapeHtml(src600) + ' 600w, ' + escapeHtml(src800) + ' 800w"'
        + ' sizes="(max-width: 767px) 75vw, 25vw"'
        + ' alt="' + escapeHtml(image.alt || product.title) + '"'
        + ' loading="lazy" width="600" height="750">';
    } else {
      imageHTML = '<div class="og-pdp-complete__card-img-placeholder">'
        + '<span>' + escapeHtml(product.title.substring(0, 20)) + '</span>'
        + '</div>';
    }

    var rawPrice = null;
    if (product.price_min != null) {
      rawPrice = product.price_min;
    } else if (product.variants && product.variants[0] && product.variants[0].price != null) {
      rawPrice = product.variants[0].price;
    } else if (product.price != null) {
      rawPrice = product.price;
    }
    var price = formatPrice(rawPrice);

    var variantId = '';
    var available = false;
    var hasMultipleVariants = product.variants && product.variants.length > 1;

    if (product.variants && product.variants.length > 0) {
      for (var vi = 0; vi < product.variants.length; vi++) {
        if (product.variants[vi].available) {
          available = true;
          variantId = product.variants[vi].id;
          break;
        }
      }
      if (!variantId) variantId = product.variants[0].id;
    }

    var url = product.url;
    var title = product.title;

    // ── 修复2：多变体 → Choose跳产品页；单变体 → Add直接加购 ──
    var btnHTML;
    if (!available) {
      btnHTML = '<button class="og-pdp-complete__card-btn og-pdp-complete__card-btn--sold-out"'
        + ' disabled type="button">Sold Out</button>';
    } else if (hasMultipleVariants) {
      btnHTML = '<a'
        + ' class="og-pdp-complete__card-btn og-pdp-complete__card-btn--choose"'
        + ' href="' + escapeHtml(url) + '"'
        + ' aria-label="Choose options for ' + escapeHtml(title) + '">'
        + 'Choose</a>';
    } else {
      btnHTML = '<button'
        + ' class="og-pdp-complete__card-btn"'
        + ' data-variant-id="' + escapeHtml(String(variantId)) + '"'
        + ' data-product-url="' + escapeHtml(url) + '"'
        + ' data-product-title="' + escapeHtml(title) + '"'
        + ' aria-label="Add ' + escapeHtml(title) + ' to cart"'
        + ' type="button">Add</button>';
    }

    return '<article class="og-pdp-complete__card" role="listitem"'
      + ' data-product-id="' + escapeHtml(String(product.id)) + '">'
      + '<a href="' + escapeHtml(url) + '" class="og-pdp-complete__card-image-link"'
      + ' aria-label="' + escapeHtml(title) + '" tabindex="-1">'
      + imageHTML
      + '</a>'
      + '<div class="og-pdp-complete__card-body">'
      + '<a href="' + escapeHtml(url) + '" class="og-pdp-complete__card-title-link">'
      + '<h3 class="og-pdp-complete__card-title">' + escapeHtml(title) + '</h3>'
      + '</a>'
      + '<div class="og-pdp-complete__card-meta">'
      + '<span class="og-pdp-complete__card-price">' + escapeHtml(price) + '</span>'
      + '</div>'
      + btnHTML
      + '</div>'
      + '</article>';
  }

  // ── 通用：把产品列表渲染进占位卡 ────────────────────────────
  function renderIntoPlaceholders(grid, products, shownIds) {
    var placeholders = grid.querySelectorAll('[data-placeholder="true"]');
    var filled = 0;
    for (var i = 0; i < products.length && filled < placeholders.length; i++) {
      var p = products[i];
      if (shownIds.indexOf(String(p.id)) !== -1) continue;
      var placeholder = placeholders[filled];
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = buildCardHTML(p);
      var realCard = tempDiv.firstElementChild;
      placeholder.parentNode.replaceChild(realCard, placeholder);
      shownIds.push(String(p.id));
      filled++;
    }
  }

  // ── 清除剩余占位卡 ───────────────────────────────────────────
  function clearPlaceholders(grid) {
    grid.querySelectorAll('[data-placeholder="true"]').forEach(function (el) {
      el.remove();
    });
  }

  // ── JS层4：/products.json 最新产品（终极兜底）───────────────
  function fallbackToLatestProducts(grid, shownIds) {
    if (!grid.querySelectorAll('[data-placeholder="true"]').length) return;
    fetch('/products.json?limit=12&sort_by=created-descending')
      .then(function (res) {
        if (!res.ok) throw new Error('Products API failed');
        return res.json();
      })
      .then(function (data) {
        renderIntoPlaceholders(grid, data.products || [], shownIds);
        clearPlaceholders(grid);
      })
      .catch(function () {
        clearPlaceholders(grid);
      });
  }

  // ── JS层3：Recommendations API → 不足则触发层4 ──────────────
  function fillWithRecommendations(section) {
    var grid = section.querySelector('.og-pdp-complete__grid');
    if (!grid) return;
    if (!grid.querySelectorAll('[data-placeholder="true"]').length) return;
    var productId = section.dataset.productId;
    if (!productId) return;
    var shownIdsStr = grid.dataset.shownIds || '';
    var shownIds = shownIdsStr.split(',').filter(Boolean);
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
      .then(function (res) {
        if (!res.ok) throw new Error('Recommendations API failed');
        return res.json();
      })
      .then(function (data) {
        var products = data.products || [];
        if (products.length > 0) renderIntoPlaceholders(grid, products, shownIds);
        fallbackToLatestProducts(grid, shownIds);
      })
      .catch(function () {
        fallbackToLatestProducts(grid, shownIds);
      });
  }

  // ── Toast 控制 ───────────────────────────────────────────────
  var toast = document.getElementById('og-complete-toast');
  var toastTimer = null;

  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    toast.classList.add('og-pdp-complete__toast--visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('og-pdp-complete__toast--visible');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 2500);
  }

  // ── 静默加购（修复3：失败跳产品页）──────────────────────────
  function addToCart(variantId, productUrl, btn) {
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        btn.textContent = '✓';
        showToast();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          btn.textContent = 'Add';
          btn.disabled = false;
        }, 2500);
      })
      .catch(function () {
        // 加购失败 → 跳转产品页让用户选规格
        if (productUrl) {
          window.location.href = productUrl;
        } else {
          btn.textContent = 'Add';
          btn.disabled = false;
        }
      });
  }

  // ── 事件委托 ─────────────────────────────────────────────────
  document.querySelectorAll('.og-pdp-complete').forEach(function (section) {
    fillWithRecommendations(section);
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.og-pdp-complete__card-btn');
      // A标签（Choose按钮）让浏览器原生跳转，不拦截
      if (!btn || btn.disabled || btn.tagName === 'A') return;
      var variantId = btn.dataset.variantId;
      var productUrl = btn.dataset.productUrl;
      if (!variantId) return;
      addToCart(variantId, productUrl, btn);
    });
  });

})();
